"use client";
export const createTypography = (config) => {
  const { isDyslexic } = config;

  const fontFamily = isDyslexic
    ? '"OpenDyslexic", "Comic Sans MS"'
    : '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"';

  return {
    typography: {
      fontFamily: fontFamily,
      body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.5,
        fontFamily: fontFamily,
      },
      body2: {
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.57,
        fontFamily: fontFamily,
      },
      body3: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 1.5,
        fontFamily: fontFamily,
      },
      button: {
        fontWeight: 600,
        fontFamily: fontFamily,
      },
      caption: {
        fontSize: "0.75rem",
        fontWeight: 500,
        lineHeight: 1.66,
        fontFamily: fontFamily,
      },
      subtitle1: {
        fontSize: "1rem",
        fontWeight: 500,
        lineHeight: 1.57,
        fontFamily: fontFamily,
      },
      subtitle2: {
        fontSize: "0.875rem",
        fontWeight: 500,
        lineHeight: 1.57,
        fontFamily: fontFamily,
      },
      overline: {
        fontSize: "0.75rem",
        fontWeight: 600,
        letterSpacing: "0.5px",
        lineHeight: 2.5,
        textTransform: "uppercase",
        fontFamily: fontFamily,
      },
      h1: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "3.5rem",
        lineHeight: 1.2,
      },
      h2: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "3rem",
        lineHeight: 1.2,
      },
      h3: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "2.25rem",
        lineHeight: 1.2,
      },
      h4: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "2rem",
        lineHeight: 1.2,
      },
      h5: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: 1.2,
      },
      h6: {
        fontFamily: fontFamily,
        fontWeight: 700,
        fontSize: "1.125rem",
        lineHeight: 1.2,
      },
    },
  };
};
